import { render, staticRenderFns } from "./EditorHeaderGoogleSlide.vue?vue&type=template&id=06cb9972&scoped=true&"
import script from "./EditorHeaderGoogleSlide.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderGoogleSlide.vue?vue&type=script&lang=js&"
import style0 from "./EditorHeaderGoogleSlide.vue?vue&type=style&index=0&id=06cb9972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb9972",
  null
  
)

export default component.exports